import { styled, Box } from '@mui/system';
import { Paper } from '@mui/material';
import BG from '../../../../assets/images/AuthBack.svg';
import BG_RESPONSIVE from '../../../../assets/images/BG_RESP.png';
import ClipBG from '../../../../assets/dashback.png';
import BG_LEFT_TOP from '../../../../assets/dashtopleft.svg';
import BG_BOT_RIGHT from '../../../../assets/botrightdash.svg';

export const StyledAuth = styled(Paper)(({ theme }) => ({
    gridColumnStart: "2",
    marginTop: "4rem",
    marginBottom: "2rem",
    background: "white",
    borderRadius: "12px",
    paddingBottom: "4rem",
    boxShadow: "0px 40px 40px 40px rgba(0, 0, 0, 0.12)",
    minWidth: "510px",
    minHeight: "590px",
    ".form-container": {
        width: "320px",
        marginTop: "4rem",
    },
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down(1025)]: {
        gridColumnStart: "1",
        maxWidth: "80%",
        width: "80%",
        minWidth: "280px",
        minHeight: "340px",
        ".form-container": {
            maxWidth: "80%",
            minWidth: "80%",
        },
    },
}));

export const ScrollableBox = styled(Box)(({ theme }) => ({
    overflowY: "scroll",
    maxHeight: "480px",
    scrollbarWidth: "none", // Firefox
    "-ms-overflow-style": "none", // Internet Explorer 10+
    "&::-webkit-scrollbar": {
        display: "none", // Chrome, Safari, and Opera
    },
    [theme.breakpoints.down(1370)]: {
        maxHeight: "370px",
    },
}));

export const AuthContainer = styled(Box)(({ theme }) => ({
    position: 'absolute',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    justifyContent: 'center',
    alignContent: 'center',
    justifyItems: 'center',
    alignItems: 'center',
    backgroundImage: `url(${BG})`,
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    minHeight: '100vh',
    [theme.breakpoints.down(1025)]: {
      gridTemplateColumns: '1fr',
      position: 'static',
      minHeight: '100vh',
      backgroundImage: `url(${BG_RESPONSIVE})`
    }
}));

export const LoginContainer = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "0.85fr 1.15fr",
    background: "#ffffff",
    minHeight: "100vh",
    [theme.breakpoints.down(1025)]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "static",
        minHeight: "100vh",
        clipPath: "unset",
        backgroundImage: `url(${BG_RESPONSIVE})`,
    },
}));
export const LoginStyledAuth = styled(Box)(({ theme }) => ({
    backgroundImage: `url(${ClipBG})`,
    clipPath: "polygon(35% 0, 100% 0, 100% 100%, 0% 100%)",
    zIndex: 100,
    right: 0,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    ".form-container": {
        zIndex: 100,
        marginRight: "70px",
        width: "320px",
        marginTop: "4rem",
        background: "#ffffff",
        padding: "70px 95px 155px 95px",
        borderRadius: "12px",
        boxShadow: "0px 40px 40px 40px rgba(0, 0, 0, 0.12)",
        [theme.breakpoints.down(1370)]: {
            marginTop: "3rem",
            padding: "50px 80px 80px 80px",
        },
        [theme.breakpoints.down(1200)]: {
            marginTop: "3rem",
            padding: "50px 65px 115px 65px",
        },
    },
    ":before": {
        content: '""',
        background: `url(${BG_LEFT_TOP})`,
        height: "140px",
        width: "140px",
        position: "fixed",
        left: "60%",
    },
    ":after": {
        content: '""',
        background: `url(${BG_BOT_RIGHT})`,
        right: "-59px",
        height: "456px",
        width: "288px",
        position: "fixed",
        bottom: "0",
    },
    [theme.breakpoints.down(1367)]: {
        // Todo: with help of clipPath will inclined the edges
        clipPath: "polygon(30% 0, 100% 0, 100% 100%, 0% 100%)",
        ":before": {
            content: '""',
            background: `url(${BG_LEFT_TOP})`,
            height: "140px",
            width: "140px",
            position: "fixed",
            left: "55%",
        },
    },
    [theme.breakpoints.down(1025)]: {
        paddingLeft: "70px",

        clipPath: "unset",
        ":before": {
            content: '""',
            background: "unset",
        },
        ":after": {
            content: '""',
            background: "unset",
        },
    },
}));
